<template>
  <v-container fluid
               class="tfb-smaller-container tfb-component-container">
    <v-row>
      <v-col cols="12">
        <v-container fluid
                     class="drop-shadow background-white px-md-10 pb-5">
          <v-row>
            <v-col cols="12">
              <span class="tfb-title-text-small text-uppercase">
                Change Password
              </span>
            </v-col>
          </v-row>
          <v-row v-if="passwordSuccess">
            <v-col cols="12"
                   class="py-0">
              <v-alert type="success">
                You have successfully changed your account password.
              </v-alert>
            </v-col>
          </v-row>
          <ValidationObserver ref="obv" v-slot="{ handleSubmit }">
            <v-form role="form"
                    @submit.stop.prevent="handleSubmit(updatePassword)"
                    v-if="!passwordSuccess">
              <v-row>
                <v-col cols="12">
                  <text-input rules="required|all_allowed|min:16|max:99|confirmed:password|hasMoreThanNConcurrentLetters:2|hasNUppercaseLetters:1|hasNNumbers:2"
                              minlength="16"
                              maxlength="99"
                              label="New Password"
                              v-model="passWord"
                              type="password"
                              autocomplete="new-password"
                              :disabled="formDisabled"></text-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <text-input rules="required|all_allowed|min:16|max:99"
                              minlength="16"
                              maxlength="99"
                              label="Confirm New Password"
                              v-model="confirmPassWord"
                              type="password"
                              autocomplete="new-password"
                              :disabled="formDisabled"
                              vid="password"></text-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <h4>Password requirements:</h4>
                  <ul>
                    <li style="list-style-type:none;">
                      <v-icon v-if="passwordLengthValidation">mdi-check</v-icon><v-icon v-else>mdi-close</v-icon> Between 16 and 99 chracters
                    </li>
                    <li style="list-style-type:none;">
                      <v-icon v-if="passwordNumbersValidation">mdi-check</v-icon><v-icon v-else>mdi-close</v-icon> At least two numbers
                    </li>
                    <li style="list-style-type:none;">
                      <v-icon v-if="passwordAlphasValidation">mdi-check</v-icon><v-icon v-else>mdi-close</v-icon> At least two letters
                    </li>
                    <li style="list-style-type:none;">
                      <v-icon v-if="passwordCapitalsValidation">mdi-check</v-icon><v-icon v-else>mdi-close</v-icon> At least one uppercase letter
                    </li>
                    <li style="list-style-type:none;">
                      <v-icon v-if="passwordRepeatingValidation">mdi-check</v-icon><v-icon v-else>mdi-close</v-icon> No more than two concurrent like characters
                    </li>
                    <li style="list-style-type:none;">
                      <v-icon v-if="passwordSpecialCharactersValidation">mdi-check</v-icon><v-icon v-else>mdi-close</v-icon> Does not include a colon
                    </li>
                  </ul>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"
                       sm="6"
                       md="4">
                  <v-btn block
                         :disabled="formDisabled"
                         type="submit"
                         class="tfb-button background-red">Submit</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
          <v-overlay absolute
                     :value="saveOverlay">
            <v-progress-circular indeterminate
                                 size="64"></v-progress-circular>
          </v-overlay>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { dispatch } from 'vuex-pathify';
  import { ValidationObserver } from 'vee-validate';
  import tfbHelperMixin from '@/mixins/helpers';

  export default {
    name: 'PasswordChanges',
    mixins: [tfbHelperMixin],
    components: {
      ValidationObserver,
    },
    data() {
      return {
        saveOverlay: false,
        formDisabled: false,
        currentPassWord: '',
        passWord: '',
        confirmPassWord: '',
        passwordSuccess: false,
      };
    },
    computed: {
      userName() {
        try {
          return this.$store.getters['member/userName'];
        } catch (error) {
          return '';
        }
      },
      passwordLengthValidation() {
        return this.passWord.length >= 16 && this.passWord.length <= 99;
      },
      passwordNumbersValidation() {
        return this.hasNNumericCharacters(this.passWord, 2);
      },
      passwordAlphasValidation() {
        return this.hasNAlphaCharacters(this.passWord, 2);
      },
      passwordCapitalsValidation() {
        return this.hasNUppercaseCharacters(this.passWord, 1);
      },
      passwordRepeatingValidation() {
        return this.hasMoreThanNConcurrentLetters(this.passWord, 2);
      },
      passwordSpecialCharactersValidation() {
        return !this.containsString(this.passWord, ':');
      },
    },
    methods: {
      updatePassword() {
        this.passwordSuccess = false;
        this.saveOverlay = true;
        dispatch('member/updatePassword', { sUserName: this.userName, sNewPassword: this.passWord, sTfbId: this.trackingId })
          .then((updateResponse) => {
            if (updateResponse && updateResponse.indexOf('Your password has been updated') >= 0) {
              // Update was successful
              this.passwordSuccess = true;
              this.saveOverlay = false;
            } else {
              dispatch('app/setErrorMessage', updateResponse);
              this.saveOverlay = false;
            }
          })
          .catch((error) => {
            dispatch('app/setErrorMessage', error);
            this.saveOverlay = false;
          });
      },
    },
    mounted() {
      if (!this.isMemberRole) {
        // Not the member, don't allow changes
        this.formDisabled = true;
      }
    },
  };
</script>
<style lang="scss">

</style>
